import React from 'react';
import { TimePicker } from '@mui/lab';
import { Controller } from 'react-hook-form';
import { AppDatePickerStyled, AppDatePickerTextStyled } from "./AppDatePicker-styles"

export function AppDatePicker({
  field,
  control,
  errors,
  getValues,
  setValue,
  size = 'small',
  readOnly,
  editable = true,
  onValueChange = () => { }
}) {

  return (
    <Controller
      name={field.id}
      defaultValue={field.defaultValue || null}
      control={control}
      render={({ field: { onChange, value } }) => {
        if (field?.category === 'time') {
          return (
            <TimePicker
              label={field?.label}
              value={value}
              ampm={field?.ampm}
              onChange={(newValue) => {
                onChange(newValue)
              }}
              renderInput={(params) => {
                const error = Boolean(errors?.[field.id]?.type)

                return (
                  <AppDatePickerTextStyled
                  size={size}
                  {...params}
                  required={Boolean(field?.required)}
                  error={error}
                  helperText={error ? errors?.[field.id]?.message : null}
                  onKeyDown={e => {
                    if (!editable) e.preventDefault()
                  }}
                />
                )
              }}
            />
            // <KeyboardTimePicker
            //   className={classes.rootAppDatePicker}
            //   fullWidth
            //   disableToolbar
            //   variant="dialog"
            //   margin="normal"
            //   id="app-time-picker"
            //   format={field?.props?.format ?? 'hh:mm:ss'}
            //   ampm={false}
            //   minutesStep={5}
            //   label={field.label}
            //   value={value}
            //   onChange={onChange}
            //   KeyboardButtonProps={{
            //     'aria-label': 'change time'
            //   }}
            //   InputLabelProps={{
            //     shrink: true
            //   }}
            //   size={size}
            //   autoOk={true}
            //   {...(field.props || {})}
            //   // initialFocusedDate={value}
            //   // openTo={value ? 'minutes' : 'hours'}
            // />
          );
        }
        return (
          <AppDatePickerStyled
            views={field?.views || ['day']}
            label={field.label}
            value={value}
            onChange={(date) => {
              onChange(date);
              onValueChange({
                id: field.id,
                value: date
              });
            }}
            renderInput={(params) => {
              const error = Boolean(errors?.[field.id]?.type)
              return (
                <AppDatePickerTextStyled
                  size={size} {...params}
                  required={Boolean(field?.required)}
                  error={error}
                  helperText={error ? errors?.[field.id]?.message : null}
                  onKeyDown={e => {
                    if (!editable) e.preventDefault()
                  }}
                />
              )
            }}
            inputFormat={field?.format || "dd/MM/yyyy"}
            readOnly={Boolean(readOnly)}
          // disableToolbar
          // variant="inline"
          // format={field?.formatdate || 'MM/yyyy'}
          // margin="normal"
          // id="app-date-picker-inline"
          // inputVariant="outlined"
          // autoOk={true}
          // InputLabelProps={{
          //   shrink: true
          // }}
          // readOnly={Boolean(readOnly)}
          // // InputProps={{
          // //   readOnly: Boolean(readOnly)
          // // }}
          // // views={['year', 'month']}
          // size={size}
          // label={field.label}
          // value={value}
          // onChange={(date, dateStr) => {
          //   onChange(date);
          //   onValueChange({
          //     id: field.id,
          //     value: dateStr
          //   });
          // }}
          // onClose={() => {
          //   onValueChange({
          //     id: field.id,
          //     value: value
          //   });
          // }}
          // onKeyDown={(e) => {
          //   if (e.code === 'Enter') {
          //     onValueChange({
          //       id: field.id,
          //       value: value
          //     });
          //   }
          // }}
          // KeyboardButtonProps={{
          //   'aria-label': 'change date'
          // }}
          // {...(field.props || {})}
          />
        );
      }}
    />
  );
}

// export function AppRangeDate({
//   label = '',
//   size = 'small',
//   readOnly = false,
//   format = 'yyyy/MM/dd',
//   type = 'date',
//   rangeDate,
//   setRangeDate = () => {}
// }) {
//   const classes = useStyles();
//   const fromDate = rangeDate?.from;
//   const toDate = rangeDate?.to;

//   return (
//     <Box className={classes.rootAppRangeDate}>
//       {type === 'date' ? (
//         <KeyboardDatePicker
//           fullWidth
//           disableToolbar
//           variant="inline"
//           format={format}
//           margin="normal"
//           id="app-date-picker-inline"
//           inputVariant="outlined"
//           autoOk={true}
//           InputLabelProps={{
//             shrink: true
//           }}
//           readOnly={Boolean(readOnly)}
//           InputProps={{
//             readOnly: Boolean(readOnly)
//           }}
//           size={size}
//           label={label}
//           value={fromDate}
//           onChange={(date, dateStr) => {
//             setRangeDate((p) => ({
//               ...p,
//               from: date
//             }));
//           }}
//           onClose={() => {}}
//           onKeyDown={(e) => {}}
//           KeyboardButtonProps={{
//             'aria-label': 'change date'
//           }}
//         />
//       ) : (
//         <KeyboardDateTimePicker
//           variant="inline"
//           onError={() => {}}
//           fullWidth
//           ampm={true}
//           format={format}
//           id="app-datetime-picker-inline-from"
//           inputVariant="outlined"
//           autoOk={true}
//           readOnly={Boolean(readOnly)}
//           InputProps={{
//             readOnly: Boolean(readOnly)
//           }}
//           size={size}
//           label={label}
//           value={fromDate}
//           onChange={(date, _) => {
//             setRangeDate((p) => ({
//               ...p,
//               from: date
//             }));
//           }}
//         />
//       )}

//       {/*  */}
//       <div style={{ margin: 'auto' }}>
//         <ToIcon style={{ marginTop: 4 }} />
//       </div>

//       {/* to */}
//       {type === 'date' ? (
//         <KeyboardDatePicker
//           fullWidth
//           disableToolbar
//           variant="inline"
//           format={format}
//           margin="normal"
//           id="app-date-picker-inline"
//           inputVariant="outlined"
//           autoOk={true}
//           InputLabelProps={{
//             shrink: true
//           }}
//           readOnly={Boolean(readOnly)}
//           InputProps={{
//             readOnly: Boolean(readOnly)
//           }}
//           size={size}
//           label={label}
//           value={toDate}
//           onChange={(date, dateStr) => {
//             setRangeDate((p) => ({
//               ...p,
//               to: date
//             }));
//           }}
//           onClose={() => {}}
//           onKeyDown={(e) => {}}
//           KeyboardButtonProps={{
//             'aria-label': 'change date'
//           }}
//         />
//       ) : (
//         <KeyboardDateTimePicker
//           variant="inline"
//           onError={() => {}}
//           fullWidth
//           ampm={true}
//           format={format}
//           id="app-datetime-picker-inline-to"
//           inputVariant="outlined"
//           autoOk={true}
//           readOnly={Boolean(readOnly)}
//           InputProps={{
//             readOnly: Boolean(readOnly)
//           }}
//           size={size}
//           label={label}
//           value={toDate}
//           onChange={(date, _) => {
//             setRangeDate((p) => ({
//               ...p,
//               to: date
//             }));
//           }}
//         />
//       )}
//     </Box>
//   );
// }

// const hoc = (TagComponent) => (props) =>
//   <TagComponent {...props}>{props.children}</TagComponent>;

// const APP_RANGE_DATE_2_CONFIG = {
//   hasTag: false,
//   tagLabel: '',
//   tagComponent: hoc
// };
// export function AppRangeDate2({
//   label = '',
//   size = 'small',
//   format = 'MM/dd/yyyy',
//   readOnly = false,
//   rangeDate,
//   type = 'date',
//   config = APP_RANGE_DATE_2_CONFIG,
//   onChange = () => {},
//   onClose = () => {}
// }) {
//   const classes = useStyles();
//   const from = rangeDate?.from;
//   const to = rangeDate?.to;

//   function onFromChange(date) {
//     if (onChange) {
//       onChange({ from: date, to: to });
//     }
//   }

//   function onToChange(date) {
//     if (onChange) {
//       onChange({ from: from, to: date });
//     }
//   }

//   function handleClose() {
//     if (onClose) {
//       onClose(true);
//     }
//   }

//   return (
//     <Box className={classes.rootAppRangeDate2}>
//       {/* DATE FROM */}
//       {type === 'date' ? (
//         <KeyboardDatePicker
//           fullWidth
//           disableToolbar
//           variant="inline"
//           format={format}
//           margin="normal"
//           id="app-date-picker-inline-from"
//           inputVariant="outlined"
//           autoOk={true}
//           InputLabelProps={{
//             shrink: true
//           }}
//           readOnly={Boolean(readOnly)}
//           size={size}
//           label={label}
//           value={from}
//           onChange={(date, _) => onFromChange(date)}
//           onClose={() => {}}
//           onKeyDown={(e) => {}}
//           KeyboardButtonProps={{
//             'aria-label': 'change date'
//           }}
//         />
//       ) : null}

//       {/* DATETIME FROM */}
//       {type === 'datetime' ? (
//         <KeyboardDateTimePicker
//           variant="inline"
//           onError={() => {}}
//           fullWidth
//           ampm={true}
//           format={format}
//           id="app-datetime-picker-inline-from"
//           inputVariant="outlined"
//           autoOk={true}
//           readOnly={Boolean(readOnly)}
//           size={size}
//           label={label}
//           value={from}
//           onChange={(date, _) => onFromChange(date)}
//         />
//       ) : null}

//       {/*  */}
//       <div style={{ margin: 'auto 4px' }}>
//         <ToIcon style={{ marginTop: 4 }} />
//       </div>

//       {/* DATE TO */}
//       {type === 'date' ? (
//         <KeyboardDatePicker
//           fullWidth
//           disableToolbar
//           variant="inline"
//           format={format}
//           margin="normal"
//           id="app-date-picker-inline-to"
//           inputVariant="outlined"
//           autoOk={true}
//           InputLabelProps={{
//             shrink: true
//           }}
//           readOnly={Boolean(readOnly)}
//           size={size}
//           label={label}
//           value={to}
//           onChange={(date, _) => onToChange(date)}
//           onClose={() => {}}
//           onKeyDown={(e) => {}}
//           KeyboardButtonProps={{
//             'aria-label': 'change date'
//           }}
//         />
//       ) : null}
//       {/* DATETIME TO */}
//       {type === 'datetime' ? (
//         <KeyboardDateTimePicker
//           fullWidth
//           onError={() => {}}
//           ampm={true}
//           variant="inline"
//           format={format}
//           id="app-datetime-picker-inline-to"
//           inputVariant="outlined"
//           autoOk={true}
//           readOnly={Boolean(readOnly)}
//           size={size}
//           label={label}
//           value={to}
//           onChange={(date, _) => onToChange(date)}
//         />
//       ) : null}

//       {!config.hasTag ? null : config.tagComponent}
//       {/*  */}
//       <IconButton className="close-icon" onClick={handleClose}>
//         <CloseIcon />
//       </IconButton>
//     </Box>
//   );
// }
